module.exports = __webpack_public_path__ + "img/4.4c1db32b.png";